var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M34.872 0a1.94 1.94 0 0 0-.307.028A1.933 1.933 0 0 0 32.97 1.64L17.911 98l9.911-18.867 25.066-47.724L36.6 1.028l-.002-.002A1.935 1.935 0 0 0 34.872 0Zm28.387 18.294c-.722 0-1.38.396-1.716 1.035l-7.459 14.203-.008-.014-34.1 64.922 10.75-10.767 34.46-34.52 11.503-11.524-11.712-22.3a1.938 1.938 0 0 0-1.718-1.035zm32.175 8.301a1.907 1.907 0 0 0-.52.054 1.938 1.938 0 0 0-.913.514L79.18 42.006 66.623 54.589l-48.994 49.078 41.613 23.337h.002a7.846 7.846 0 0 0 7.653 0l42.532-23.647-12.145-75.153v.008a1.937 1.937 0 0 0-1.324-1.524 1.957 1.957 0 0 0-.526-.093Zm14.938 77.4-.6.049.249.146z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.373eff1f6899b873b98e492c621226be.svg";
export { ForwardRef as ReactComponent };